import * as React from "react"
import styled from "styled-components"

const StyledH1 = styled.h1`
  padding: 1rem 0;
  font-size: 2rem;
`

export const FormTitle = ({
  children,
  ...props
}: React.ComponentProps<typeof StyledH1>) => {
  return <StyledH1 {...props}>{children}</StyledH1>
}
